import React from "react";
import "./custom-filter.styles.scss";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { Select, DatePicker } from "antd";
dayjs.extend(isSameOrAfter);
const { RangePicker } = DatePicker;

const { Option } = Select;

interface SelectProps {
  className?: string;
  placeholder?: string;
  options?: Array<{ id: number | string; name: string }>;
  onChange: (value: string | number | any, option: any) => void;
  value?: string | number | undefined;
  defaultValue?: string | number | undefined;
  startDate?: string | number | undefined | any;
  endDate?: string | number | undefined | any;
  disabled?: boolean | string | number | undefined | any;
  disabledDate?: boolean | string | number | undefined | any;
  returnId?: boolean;
  required?: boolean;
  allowClear?: boolean;
  head: string;
  type: string; //'range-picker' or 'single-select'
}

const CustomFilter: React.FC<SelectProps> = (props: SelectProps) => {
  const {
    type,
    className,
    placeholder,
    onChange,
    options,
    value,
    defaultValue,
    startDate,
    endDate,
    disabled,
    disabledDate,
    returnId,
    head,
    required,
    allowClear,
  } = props;
  const propsForSelect = {
    ...(value && { value: value }),
    placeholder: placeholder,
    disabled: disabled,
    defaultValue: defaultValue,
    allowClear: allowClear,
    // onSelect: onChange,
    onChange: onChange,
  };
  return (
    <div
      className={`custom-filter-container ${
        type === "range-picker" && "select-date-container"
      } ${className ? className : ""}`}
    >
      {/* <div className="name">
        {head}
        {required && <label style={{ color: "red" }}>*</label>}
      </div> */}
      {type === "single-select" && (
        <Select {...propsForSelect}>
          {options &&
            options.map((item) => (
              <Option value={returnId ? item.id : item.name} key={item.id}>
                {item.name}
              </Option>
            ))}
        </Select>
      )}
      {type === "range-picker" && (
        <RangePicker
          allowClear={false}
          onChange={(value, dateString) =>
            onChange && onChange(value, dateString)
          }
          value={[startDate, endDate]}
          disabledDate={(d, i) =>
            !d ||
            (disabledDate == true &&
              i?.from &&
              d.isSameOrAfter(i.from.add(1, "year"))) ||
            d.isAfter(dayjs()) ||
            (disabledDate?.length > 0 &&
              disabledDate[0].startDate &&
              d.isBefore(dayjs(disabledDate[0].startDate))) ||
            (disabledDate?.length > 0 &&
              disabledDate[0].endDate &&
              d.isSameOrAfter(dayjs(disabledDate[0].endDate)))
          }
          allowEmpty
          // ranges={{
          //   Today: [dayjs(), dayjs()],
          //   Yesterday: [
          //     dayjs().subtract(1, "days"),
          //     dayjs().subtract(1, "days"),
          //   ],
          //   "Past 7 days": [dayjs().subtract(7, "days"), dayjs()],
          // }}
        />
      )}
      {type === "multi-select" && (
        <Select
          {...propsForSelect}
          mode="multiple"
          showSearch={false}
          maxTagCount={"responsive"}
          // showArrow={true}
          onChange={(value) => onChange(value, options)}
        >
          {options &&
            options.map((item) => (
              <Option value={returnId ? item.id : item.name} key={item.id}>
                {item.name}
              </Option>
            ))}
        </Select>
      )}
    </div>
  );
};

export default CustomFilter;
